import { render, staticRenderFns } from "./new_char.vue?vue&type=template&id=0846c908"
import script from "./new_char.vue?vue&type=script&lang=ts"
export * from "./new_char.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports